/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_H1_EmInputs */

const es_ab_h1_em = /** @type {(inputs: Ab_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mejor`)
};

const gl_ab_h1_em = /** @type {(inputs: Ab_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mellor`)
};

const en_ab_h1_em = /** @type {(inputs: Ab_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`best`)
};

/**
* | output |
* | --- |
* | "best" |
*
* @param {Ab_H1_EmInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_h1_em = /** @type {((inputs?: Ab_H1_EmInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_H1_EmInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_h1_em(inputs)
	if (locale === "en") return en_ab_h1_em(inputs)
	return es_ab_h1_em(inputs)
});